import { render, staticRenderFns } from "./QuranProgramStudent.vue?vue&type=template&id=37415f32&"
import script from "./QuranProgramStudent.vue?vue&type=script&lang=js&"
export * from "./QuranProgramStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports